import {connect} from 'react-redux';
import {State} from '../../../types/mx/reducers';
import {AnyAction, Dispatch} from 'redux';
import * as ModalActions from '../../../../wizard/actions/ModalActions';
import BankAccountDetailView from '../../../components/views/mx/BankAccountDetailView';
import {BankAccountDetailsDispatchProps, BankAccountDetailsProps} from '../../types/mx/containers';
import {BankAccountSummaryState} from '../../types/mx/types';
import {formatDateCustomized} from '../../../../common/utils/DateUtils';
import * as RolesConstants from '../../../constants/RolesConstants';

const mapStateToProps = (state: State, ownProps): BankAccountDetailsProps => {
    const bankAccountDetailsState: BankAccountSummaryState = !!ownProps.data && !!ownProps.data.bankAccountDetail
        ? ownProps.data.bankAccountDetail : {
            bankAccountId: '', accountNumber: '', bank: '', beneficiaryName: '', clabe: '',
            dealerAccountStatusFile: {url: ''}, dealerOfficialIdentificationFile: {url: ''},
            ownerName: '', ownerId: '', createdAt: {displayValue: '', value: 0}
        };
    const displayDate: string = bankAccountDetailsState.createdAt.displayValue;
    const valueDate: number = bankAccountDetailsState.createdAt.value;
    const lastModified: number = new Date().getTime();
    return {
        isUserGroupAdmin: state.admin.profile.roles.includes(RolesConstants.USER_GROUP_ADMIN),
        bankAccountId: bankAccountDetailsState.bankAccountId,
        accountNumber: bankAccountDetailsState.accountNumber,
        bank: bankAccountDetailsState.bank,
        beneficiaryName: bankAccountDetailsState.beneficiaryName,
        clabe: bankAccountDetailsState.clabe,
        dealerAccountStatusFile: {
            url: bankAccountDetailsState.dealerAccountStatusFile.url,
            mimeType: bankAccountDetailsState.dealerAccountStatusFile.mimeType,
            isUploaded: true
        },
        dealerOfficialIdentificationFile: {
            url: bankAccountDetailsState.dealerOfficialIdentificationFile.url,
            mimeType: bankAccountDetailsState.dealerOfficialIdentificationFile.mimeType,
            isUploaded: true
        },
        ownerName: bankAccountDetailsState.ownerName,
        ownerId: bankAccountDetailsState.ownerId,
        createdAt: {
            displayValue: !!displayDate ? displayDate : formatDateCustomized(lastModified, '·', ' · '), value: valueDate
        }
    };
};

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>): BankAccountDetailsDispatchProps => {
    return {
        onCancel: () => dispatch(ModalActions.CLOSE_MODAL_ACTION.action()),
    };
};

const mergeProps = (stateProps, dispatchProps) => {
    return {
        ...stateProps,
        ...dispatchProps
    };
};

const BankAccountDetailContainer = connect(
    mapStateToProps, mapDispatchToProps, mergeProps
)(BankAccountDetailView);

export default BankAccountDetailContainer;
